import { useEffect } from "react";
import { t } from "./i18n";
import { lp } from "./routes";

const BRAND = "Dom Żaru";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, image, jsonLd, type = "website", noindex = false }) {
  useEffect(() => {
    const clean = title ? t(String(title).replace(/\s*\|\s*(Maison de braise|Dom Żaru)$/, "")) : "";
    const full = clean ? `${clean} | ${BRAND}` : `${BRAND} — drewno opałowe, pellet i piece z dostawą`;
    const desc = description ? t(description) : undefined;
    document.title = full;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", image && image.startsWith("/") ? window.location.origin + image : image);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", window.location.origin + window.location.pathname);
    setMeta("property", "og:locale", "pl_PL");
    setMeta("property", "og:site_name", BRAND);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = window.location.origin + window.location.pathname;
    document.head.querySelectorAll("link[hreflang]").forEach((a) => a.remove());
    let s = document.getElementById("jsonld");
    if (jsonLd) {
      if (!s) { s = document.createElement("script"); s.type = "application/ld+json"; s.id = "jsonld"; document.head.appendChild(s); }
      s.textContent = JSON.stringify(jsonLd);
    } else if (s) s.remove();
  }, [title, description, image, type, noindex, JSON.stringify(jsonLd || null)]); // eslint-disable-line
}

export const breadcrumbLd = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: t(it.label), ...(it.to ? { item: window.location.origin + lp(it.to) } : {}) })),
});
